import { Options } from '..'
import { Application } from '../../../../../application/application'

export function isBackgroundCheckStep(
  application: Application,
  options: Options
) {
  const { isAtCapacity } = options
  const { dasherId, dateOfBirth, backgroundCheckResults } = application
  const hasDasher = !!dasherId
  const hasDob = !!dateOfBirth

  return (
    !isAtCapacity &&
    (!hasDasher || !hasDob || backgroundCheckResults === 'incomplete')
  )
}
